document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCounters();
  initGalleryProducto();
  initVariantesProducto();
  initBotonPromo();
});

function initBotonPromo() {
  var boton = document.querySelector('[data-ps-boton-promo]');
  if (!boton) return;
  var form = boton.closest('form');
  var cantidadInput = form ? form.querySelector('[data-ps-cantidad]') : null;
  if (!cantidadInput) return;
  boton.addEventListener('click', function () {
    cantidadInput.value = boton.getAttribute('data-ps-cantidad-promo') || '2';
  });
}

function initReveal() {
  var els = document.querySelectorAll('.ps-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('ps-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('ps-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { io.observe(el); });
}

function initCounters() {
  var counters = document.querySelectorAll('[data-ps-counter]');
  if (!counters.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      io.unobserve(el);
      var target = parseFloat(el.getAttribute('data-ps-counter')) || 0;
      var suffix = el.getAttribute('data-ps-suffix') || '';
      var duration = 1200;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = target * eased;
        el.textContent = (Number.isInteger(target) ? Math.round(value) : value.toFixed(1)) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  counters.forEach(function (el) { io.observe(el); });
}

function initGalleryProducto() {
  var wrap = document.querySelector('[data-ps-galeria]');
  if (!wrap) return;
  var main = wrap.querySelector('[data-ps-galeria-principal]');
  var thumbs = wrap.querySelectorAll('[data-ps-galeria-thumb]');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-ps-full');
      var alt = thumb.getAttribute('data-ps-alt') || '';
      if (!full) return;
      main.src = full;
      main.alt = alt;
      thumbs.forEach(function (t) { t.classList.remove('ps-thumb-activo'); });
      thumb.classList.add('ps-thumb-activo');
    });
  });
}

function initVariantesProducto() {
  var form = document.querySelector('[data-ps-form-producto]');
  if (!form) return;
  var dataEl = form.querySelector('[data-ps-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var selects = form.querySelectorAll('[data-ps-opcion]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-ps-precio]');
  var precioCompareEl = document.querySelector('[data-ps-precio-compare]');
  var botonEl = form.querySelector('[data-ps-boton-comprar]');

  function moneyFmt(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function actualizar() {
    var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
    var match = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!match) return;
    idInput.value = match.id;
    if (precioEl) precioEl.textContent = moneyFmt(match.price);
    if (precioCompareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        precioCompareEl.textContent = moneyFmt(match.compare_at_price);
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (botonEl) {
      if (match.available) {
        botonEl.disabled = false;
        botonEl.textContent = botonEl.getAttribute('data-ps-texto-disponible');
      } else {
        botonEl.disabled = true;
        botonEl.textContent = botonEl.getAttribute('data-ps-texto-agotado');
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}
